import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ErrorPage from 'next/error';
import Schedule from '../../endpoints/Schedule/Schedule';
import {
  fetchMemberDriveStatus,
  addMemberDriveElements,
} from '../../utils/membershipUtils';
import fetchSchedule from '../api/schedule/fetchSchedule';

const SchedulePage = ({ schedule, errorCode }) => {
  if (!schedule || errorCode) return <ErrorPage statusCode={404} />;
  useEffect(() => {
    fetchMemberDriveStatus().then((data) => {
      addMemberDriveElements(data);
    });
  }, []);

  return <Schedule schedule={schedule} />;
};

export async function getServerSideProps({ params: { day }, res }) {
  const validDays = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
  if (!validDays.includes(day)) {
    return { notFound: true };
  }

  const props = await fetchSchedule(day);
  const errorCode = res.statusCode > 200 ? res.statusCode : false;
  res.setHeader('Cache-Control', 'public, max-age=60');

  return {
    props: {
      schedule: { props, day },
      errorCode: errorCode || null,
    },
  };
}

SchedulePage.propTypes = {
  schedule: PropTypes.object,
  errorCode: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
};

export default SchedulePage;
